import { getRequest, postRequest } from './request'
import { DOMAIN } from './constant'
import { PaymentChannel, ProductType } from '@shared/constants/payment'

// 创建支付宝订单
export const createAlipayOrder = (data: { productType: ProductType, couponCode?: string }) => {
  return postRequest(`${DOMAIN}/api/payment/create-order`, {
    productType: data.productType,
    paymentChannel: PaymentChannel.ALIPAY,
    couponCode: data.couponCode,
  })
}


// 查询订单状态
export const queryOrderStatus = (orderId: string) => {
  return postRequest(`${DOMAIN}/api/payment/query-order`, {
    out_trade_no: orderId,
    paymentChannel: PaymentChannel.ALIPAY,
  })
}

// 优惠码校验
export const checkCoupon = (couponCode: string, scope: string) => {
  return postRequest(`${DOMAIN}/api/coupon/check`, {
    couponCode,
    scope,
  })
}
